import React from 'react'
import './style.css'
import { useCountContext } from "../../utils/global";

function Index(props) {

  const [state, dispatch] = useCountContext();
  return (
    <div className={props.id === "ldoor" ? state.left : state.right} id={props.id} >
      {props.children}
    </div>

  )
}

export default Index
